import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptSomme80 = () => {
  return (
    <DepartmentTemplate
      department="Somme"
      departmentNumber="80"
      cities="Amiens, Abbeville, Péronne, Albert"
      region="Hauts-de-France"
    />
  );
};

export default DeptSomme80;
